<template>
    <span v-if="canReprocess">
        <v-btn outlined :disabled="disabled" @click="open"><v-icon left>mdi-refresh-auto</v-icon>Rielabora piani 8D</v-btn>
        <v-dialog v-model="dialog" max-width="840" :persistent="busy" scrollable aria-label="Rielaborazione dei piani 8D">
            <v-card>
                <v-card-title>Rielaborazione dei piani 8D</v-card-title>
                <v-card-text>
                    <p>Completa i dati mancanti di tutti gli 8D cliente e interni: trattamento entro 7 giorni, azione correttiva entro 30 giorni dalla creazione e proposta della causa da confermare.</p>
                    <p>Conserva i dati già compilati, le esecuzioni e gli esiti registrati. Non chiude le NC e non invia comunicazioni.</p>
                    <v-progress-linear v-if="busy" indeterminate aria-label="Elaborazione dei piani 8D" />
                    <v-alert v-if="error" type="error" text role="alert">{{ error }}</v-alert>
                    <template v-if="report">
                        <p role="status">{{ report.total }} 8D esaminati · {{ report.to_update }} da aggiornare</p>
                        <v-alert v-if="applied" :type="report.conflicts.length ? 'warning' : 'success'" text role="status">Piani aggiornati: {{ report.updated }}. Modificati durante l’operazione: {{ report.conflicts.length }}. Rileggi l’anteprima per controllare eventuali schede rimanenti.</v-alert>
                        <v-alert v-if="report.skipped.length" type="warning" text>Da controllare manualmente: {{ report.skipped.length }}. Questi 8D non vengono modificati.
                            <ul><li v-for="(item, index) in report.skipped" :key="index">{{ item.numero }}<template v-if="item.riga"> / {{ item.riga }}</template>: {{ item.reason }}</li></ul>
                        </v-alert>
                        <ul v-if="!applied"><li v-for="(item, index) in report.items" :key="index">{{ item.numero }}<template v-if="item.riga"> / {{ item.riga }}</template></li></ul>
                        <p v-if="!report.to_update && !report.skipped.length">Tutti i piani sono già aggiornati.</p>
                    </template>
                </v-card-text>
                <v-card-actions class="flex-wrap">
                    <v-btn text :disabled="busy" @click="dialog=false">Chiudi</v-btn><v-spacer />
                    <v-btn outlined :disabled="busy" @click="preview">Rileggi anteprima</v-btn>
                    <v-btn v-if="report && report.to_update && !applied" color="primary" :loading="busy" :disabled="busy || Boolean(error)" @click="apply">Applica a {{ report.to_update }} {{ report.to_update === 1 ? 'piano' : 'piani' }} 8D</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
export default {
    name: "Nc8dReprocess",
    props: {disabled: Boolean},
    data: () => ({dialog:false,busy:false,report:null,error:"",applied:false}),
    computed: {
        canReprocess() {
            const user=this.$store.state.user.userdata;
            return user.admin || (user.groups || []).some(group=>["Amministrazione","Qualità"].includes(group));
        },
    },
    methods: {
        open() {this.dialog=true;this.preview();},
        async preview() {
            this.busy=true;this.error="";this.report=null;this.applied=false;
            try {this.report=(await this.$work.get("/qualita/8d/rielabora/",{},false,null,{timeout:60000})).data;}
            catch(error) {this.error=error?.response?.data?.detail || "Anteprima non disponibile. Riprova quando le fonti sono disponibili.";}
            finally {this.busy=false;}
        },
        async apply() {
            if(this.busy || !this.report || this.applied)return;
            this.busy=true;this.error="";
            try {this.report=(await this.$work.post("/qualita/8d/rielabora/",{fingerprint:this.report.fingerprint})).data;this.applied=true;this.$emit("updated");}
            catch(error) {this.error=error?.response?.data?.detail || "Esito non confermato. Rileggi l’anteprima prima di riprovare.";}
            finally {this.busy=false;}
        },
    },
};
</script>
